import React from 'react';
import PropTypes from 'prop-types';
import InfoCircleFilled from './InfoCircleFilled'

const InfoText = ({ text, children }) => {
  return (
    <div className="text-xs my-2 p-0 flex item-start relative">
      <InfoCircleFilled className="p-0 mr-1 mt-[-5px]" width={36} height={36} />
      <span>{text || children}</span>
    </div>
  );
};

InfoText.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
};

export default InfoText;